// shared components
import AzureStyleDateRangeSelector from '@/components/ui/datetime/AzureStyleDateRangeSelector';

// feature-hooks
import { useEsgRangePresets } from '@/features/energyxplorer/hooks/useEsgRangePresets';
import { useEsgUrlDateRange } from '@/features/energyxplorer/hooks/useEsgUrlDateRange';

const EsgDateRangeSelector = () => {
  const presets = useEsgRangePresets();

  // Centralized URL + Luxon handling
  const { range, setRange } = useEsgUrlDateRange({
    zone: 'Europe/Copenhagen',
    defaultDays: 30,
  });
  const [from, to] = range;

  return (
    <AzureStyleDateRangeSelector
      from={from}
      to={to}
      presets={presets}
      includeTime={false}
      disableFuture
      onRangeChange={({ from: nextFrom, to: nextTo }) =>
        setRange(nextFrom, nextTo, { roundToDay: true, clampToNow: true })
      }
    />
  );
};

export default EsgDateRangeSelector;
